<div class="date-field-dropdown" (click)="$event.stopPropagation()">
  <mat-label class="dropdown-header">Filter by Date Field</mat-label>

  <mat-form-field appearance="outline" class="date-field-form-field custom-alert-date-form-field" (click)="$event.stopPropagation()">
    <mat-select #selectElement [value]="selectedField" (selectionChange)="onFieldChange($event.value)"
      panelClass="date-field-panel" [disableOptionCentering]="true" (click)="$event.stopPropagation()">
      <mat-select-trigger class="custom-date-range-mat-select-panel">
        <div class="custom-trigger-content">
          <span class="selected-value">{{ selectedFieldName }}</span>
          <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
        </div>
      </mat-select-trigger>
      <mat-option class="custom-date-range-checkbox" *ngFor="let option of dateFieldOptions" [value]="option.id" (click)="$event.stopPropagation()">
        {{ option.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>